import { render, staticRenderFns } from "./h5editer.vue?vue&type=template&id=64db0453&"
import script from "./h5editer.vue?vue&type=script&lang=js&"
export * from "./h5editer.vue?vue&type=script&lang=js&"
import style0 from "./h5editer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports